var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDoubleRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none",
    rx: 0,
    ry: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68007 18.4202C5.79007 18.5402 5.95007 18.6002 6.10007 18.6002C6.25007 18.6002 6.41007 18.5402 6.53007 18.4202L12.5301 12.4202C12.7601 12.1802 12.7601 11.8002 12.5301 11.5702L6.53007 5.57021C6.29007 5.34021 5.91007 5.34021 5.68007 5.57021C5.45007 5.81021 5.45007 6.19021 5.68007 6.42021L11.2501 12.0002L5.68007 17.5702C5.45007 17.8102 5.45007 18.1902 5.68007 18.4202ZM11.4801 18.4202C11.5901 18.5402 11.7501 18.6002 11.9001 18.6002C12.0501 18.6002 12.2101 18.5402 12.3301 18.4202L18.3301 12.4202C18.5601 12.1802 18.5601 11.8002 18.3301 11.5702L12.3301 5.57021C12.0901 5.34021 11.7101 5.34021 11.4801 5.57021C11.2501 5.81021 11.2501 6.19021 11.4801 6.42021L17.0601 11.9902L11.4801 17.5702C11.2501 17.8102 11.2501 18.1902 11.4801 18.4202Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDoubleRight);
export default __webpack_public_path__ + "static/media/chevron-double-right.f3b543c92b7e2df02d528ce4dde430bc.svg";
export { ForwardRef as ReactComponent };